import { ActivityStatusCode } from '../../api/dto';
import { StatusColor } from './StatusColor';

export const ActivityStatusColorMapping: Record<ActivityStatusCode, StatusColor> = {
    [ActivityStatusCode.NEW]: StatusColor.PRIMARY,
    [ActivityStatusCode.DRAFT]: StatusColor.PRIMARY,
    [ActivityStatusCode.SAVED]: StatusColor.PRIMARY,
    [ActivityStatusCode.WAITING_SYSTEM_APPROVAL]: StatusColor.WARNING,
    [ActivityStatusCode.WAITING_MEETINGS_APPROVAL]: StatusColor.WARNING,
    [ActivityStatusCode.WAITING_TO_BE_SCHEDULED]: StatusColor.WARNING,
    [ActivityStatusCode.SCHEDULED]: StatusColor.SUCCESS,
    [ActivityStatusCode.WAITING_SAFETY_APPROVAL]: StatusColor.WARNING,
    [ActivityStatusCode.APPROVED]: StatusColor.SUCCESS,
    [ActivityStatusCode.IN_PROGRESS]: StatusColor.SUCCESS,
    [ActivityStatusCode.LATE]: StatusColor.WARNING,
    [ActivityStatusCode.INTERRUPTED]: StatusColor.WARNING,
    [ActivityStatusCode.CLOSED]: StatusColor.NORMAL,
    [ActivityStatusCode.REJECTED]: StatusColor.ERROR,
    [ActivityStatusCode.CANCELLED]: StatusColor.ERROR,
    [ActivityStatusCode.FINISHED]: StatusColor.NORMAL,
    [ActivityStatusCode.WAITING_APPROVAL]: StatusColor.WARNING,
    [ActivityStatusCode.WAITING_VISIT_SAFETY_APPROVAL]: StatusColor.WARNING,
    [ActivityStatusCode.WAITING_SURFACE_APPROVAL]: StatusColor.WARNING,
};
